if (!customElements.get('image-zoom')) {
   customElements.define('image-zoom', class ImageZoom extends HTMLElement {
      constructor() {
         super();
         this.zoom = false;
      }

      connectedCallback(){
         this.img = this.querySelector('img');
               
         this.img.addEventListener('mouseover', (event) => {

            //only zoom for tablet and larger
            let mq = window.matchMedia('(min-width:750px)');
         
            if (mq.matches){              
               this.createZoom();
               window.requestAnimationFrame(() => {
                  this.moveZoom(event);
               });
            }
         })

         this.img.addEventListener('mouseleave', (event) => {
            this.destroyZoom();
         })  
     } 
     
     createZoom(){
       if (this.querySelector('div.media-zoom') == null) {
         let src = this.getAttribute('src');

         this.zoom = document.createElement('div');
         this.zoom.classList.add('media-zoom');
         this.zoom.style.backgroundColor = '#ffffff';
         this.zoom.style.backgroundImage = `url(${src})`;
        
          //get the actual image width and height for zooming purposes
         let img = document.createElement('img');
         img.addEventListener('load', (event) => {
           this.dataset.width = event.currentTarget.width;
           this.dataset.height = event.currentTarget.height;
         })
         img.src = src;
  
         this.appendChild(this.zoom);
 
         this.addEventListener('mousemove', (event) => {
           window.requestAnimationFrame(() => {
             this.moveZoom(event);
           });
         });
       } 
     }
 
     destroyZoom(){
       this.querySelector('div.media-zoom').remove();
     }
 
     moveZoom(event){
      if (this.zoom){
         let mx = event.clientX;
         let my = event.clientY;

         let rect = this.img.getBoundingClientRect();
         let x = mx - rect.left;
         let y = my - rect.top;    

         let px = x/rect.width; 
         let py = y/rect.height;

         let zx = (this.dataset.width * px * -1) + this.zoom.getBoundingClientRect().width/2;
         let zy = (this.dataset.height * py * -1) + this.zoom.getBoundingClientRect().height/2 - (rect.height*.33); //bump the image up slightly in the zoom rect

         this.zoom.style.left = `${x}px`;
         this.zoom.style.top = `${y}px`;
         this.zoom.style.backgroundPosition = `${zx}px ${zy}px`;
      }
       
     }
   });
 }

 